import React from 'react';
import { machineStateLabel } from './inventoryMachines';

const missing = 'No informado en la captura';
const value = (item) => item ?? missing;

export default function InventoryMachineDetails({ machine, provider }) {
  if (!machine) {
    return <p className="p-4 text-sm text-white/60">El detalle de máquina no está disponible en esta respuesta. Se requiere el backend actualizado.</p>;
  }
  const fields = [
    ['ID nativo', machine.native_id],
    ['Estado', machineStateLabel(provider, machine.state)],
    ['Tamaño / SKU / flavor', machine.size],
    ['Sistema operativo / licencia registrada', machine.os],
    ['IP privadas', machine.private_ips?.join(', ') || null],
    ['IP públicas', machine.public_ips?.join(', ') || null],
    ['Grupo de recursos', machine.resource_group],
  ];
  return (
    <div className="p-4 space-y-4 bg-violet-500/[0.04]">
      <p className="text-xs text-violet-200/70">Datos de la captura histórica. Los campos ausentes no implican que el recurso no exista.</p>
      <dl className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {fields.map(([label, field]) => (
          <div key={label}>
            <dt className="text-xs text-white/50 mb-1">{label}</dt>
            <dd className="text-sm break-all text-white/90">{value(field)}</dd>
          </div>
        ))}
      </dl>
      <h5 className="text-sm font-semibold text-violet-200">Redes e interfaces</h5>
      {machine.networks?.length ? (
        <table className="w-full text-xs">
          <thead><tr>{['Interfaz', 'Red / VPC / VNet', 'Subred'].map((label) => <th key={label} className="text-left p-2 text-white/50">{label}</th>)}</tr></thead>
          <tbody>{machine.networks.map((network, index) => (
            <tr key={index}>{['interface', 'network', 'subnet'].map((field) => <td key={field} className="p-2 break-all align-top">{value(network[field])}</td>)}</tr>
          ))}</tbody>
        </table>
      ) : <p className="text-xs text-white/60">No hay relaciones de red informadas en la captura.</p>}
      <h5 className="text-sm font-semibold text-violet-200">Discos adjuntos identificados en la captura</h5>
      {machine.disks?.length ? (
        <table className="w-full text-xs">
          <thead><tr>{['Nombre / ID', 'Capacidad (GiB)', 'Tipo', 'Dispositivo / LUN', 'Arranque', 'Cifrado'].map((label) => <th key={label} className="text-left p-2 text-white/50">{label}</th>)}</tr></thead>
          <tbody>{machine.disks.map((disk, index) => (
            <tr key={index}>
              <td className="p-2 break-all">{disk.name || disk.id || missing}</td>
              <td className="p-2">{value(disk.size_gib)}</td>
              <td className="p-2 break-all">{value(disk.type)}</td>
              <td className="p-2">{value(disk.device)}</td>
              <td className="p-2">{typeof disk.boot === 'boolean' ? (disk.boot ? 'Sí' : 'No') : missing}</td>
              <td className="p-2">{typeof disk.encrypted === 'boolean' ? (disk.encrypted ? 'Sí' : 'No') : missing}</td>
            </tr>
          ))}</tbody>
        </table>
      ) : <p className="text-xs text-white/60">No hay discos adjuntos informados en la captura; no confirma ausencia de discos.</p>}
    </div>
  );
}
